<app-splash-screen *ngIf="showSplash"></app-splash-screen>

<p-toast key="KeyHome" [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}" [baseZIndex]="5000"></p-toast>
<!--  -->
<router-outlet *ngIf="!showSplash"></router-outlet>